import { Application, Controller } from "@hotwired/stimulus";

export class AccordionController extends Controller {
  static targets = ['toggleButton', 'content']

  toggleAccordion() {
    if (this.toggleButtonTarget.classList.contains('is-open')) {
      this.close();
    } else {
      this.open();
    }
  }

  open() {
    this.contentTarget.style.maxHeight = this.contentTarget.scrollHeight + 'px';
    this.toggleButtonTarget.classList.add('is-open');
  }

  close() {
    this.contentTarget.style.maxHeight = null;
    this.toggleButtonTarget.classList.remove('is-open');
  }
}

// Registered in customer.js
